export interface ApiErrorResponse {
  Message: string;
  Type: string;
}

export function getApiErrorMessage(error: unknown): string | undefined {
  const err = error as any;
  const data = err?.response?.data;

  // Strict contract: prefer Message when present
  const msg: unknown =
    data?.Message ??
    data?.message ??
    err?.Message ??
    err?.message;

  return typeof msg === 'string' && msg.trim().length > 0 ? msg : undefined;
}

export function getApiErrorStatus(error: unknown): number | undefined {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return typeof status === 'number' ? status : undefined;
}

/** Customer self-service renting blocked (POST /rentals → 403). */
export function isBlockedFromRentingError(error: unknown): boolean {
  if (getApiErrorStatus(error) !== 403) return false;
  const msg = getApiErrorMessage(error) ?? '';
  return /blocked from creating rentals/i.test(msg);
}

